/** Sample Benchmark Records — UI placeholder only. Not live leaderboard data. */

export type BenchmarkRecordKind = 'Speed' | 'Power' | 'Aggression' | 'Hard';

export interface BenchmarkRecordRow {
  id: string;
  skill: string;
  recordType: BenchmarkRecordKind;
  ageBand: string;
  value: string;
  unit: string;
}

const BADMINTON: BenchmarkRecordRow[] = [
  { id: 'bd-r1', skill: 'Jump smash', recordType: 'Power', ageBand: 'U19', value: '428', unit: 'km/h (sample)' },
  { id: 'bd-r2', skill: 'Court sprint (4-corner)', recordType: 'Speed', ageBand: 'U13', value: '4.1', unit: 's (sample)' },
  { id: 'bd-r3', skill: 'Net kill rally', recordType: 'Aggression', ageBand: 'Senior', value: '18', unit: 'winners / min (sample)' },
  { id: 'bd-r4', skill: 'Multi-shuttle defense', recordType: 'Hard', ageBand: 'U15', value: '48', unit: 'shuttles / 60s (sample)' },
  { id: 'bd-r5', skill: 'Drive interchange', recordType: 'Speed', ageBand: 'U17', value: '62', unit: 'rallies / 2 min (sample)' },
];

const FOOTBALL: BenchmarkRecordRow[] = [
  { id: 'fb-r1', skill: '30 m sprint', recordType: 'Speed', ageBand: 'U15', value: '4.05', unit: 's (sample)' },
  { id: 'fb-r2', skill: 'Shot power', recordType: 'Power', ageBand: 'Senior', value: '118', unit: 'km/h (sample)' },
  { id: 'fb-r3', skill: 'Recovery tackle', recordType: 'Aggression', ageBand: 'U17', value: '14', unit: 'successful / game (sample)' },
  { id: 'fb-r4', skill: 'Long driven pass', recordType: 'Hard', ageBand: 'U19', value: '58', unit: 'm (sample)' },
  { id: 'fb-r5', skill: 'Vertical jump (header)', recordType: 'Power', ageBand: 'U13', value: '48', unit: 'cm (sample)' },
];

const CRICKET: BenchmarkRecordRow[] = [
  { id: 'ck-r1', skill: 'Bowl speed (new ball)', recordType: 'Speed', ageBand: 'U19', value: '148', unit: 'km/h (sample)' },
  { id: 'ck-r2', skill: 'Bat swing (pull)', recordType: 'Power', ageBand: 'Senior', value: '6', unit: 'sixes / 20 balls (sample)' },
  { id: 'ck-r3', skill: 'Direct-hit throw', recordType: 'Hard', ageBand: 'U17', value: '1.1', unit: 's from 28 m (sample)' },
  { id: 'ck-r4', skill: 'Powerplay strike', recordType: 'Aggression', ageBand: 'U15', value: '4', unit: 'boundaries / over (sample)' },
  { id: 'ck-r5', skill: 'Between-wickets sprint', recordType: 'Speed', ageBand: 'U13', value: '2.9', unit: 's (sample)' },
];

const BY_SPORT: Record<string, BenchmarkRecordRow[]> = {
  Badminton: BADMINTON,
  Football: FOOTBALL,
  Cricket: CRICKET,
};

export function getBenchmarkRecordRows(sportName: string): BenchmarkRecordRow[] {
  return BY_SPORT[sportName] ?? BADMINTON;
}
